class ComponentStickyATC extends HTMLElement {
    constructor(config) {
        super();
        this.config = config;
        this.elForm = document.querySelector('add-to-cart-form');
        if (this.elForm) this.elForm.classList.add('sticky-atc-enabled');
        this.elButton = this.querySelector('button.ProductForm__AddToCart');
        this.amountDisplay = this.querySelector('.amount-display');

        var self = this;
        this._onScroll = function() { self.updateVisibility(); };

        setTimeout(function() {
            if (self.elButton && self.elForm) {
                self.elButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    var atc = self.elForm.querySelector('button[type=submit]');
                    if (atc) atc.click();
                });
            }
            var quantityInput = document.querySelector('quantity-input.quantity-box .quantity-input');
            if (quantityInput && self.amountDisplay) {
                quantityInput.addEventListener('change', function() {
                    self.amountDisplay.innerHTML = quantityInput.value;
                });
            }
            self.updateVisibility();
        }, 300);

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(function() { self.updateVisibility(); });
        } else {
            self.updateVisibility();
        }

        var mainEl = document.querySelector('add-to-cart-form') || document.querySelector('[id^="main-product-"]');
        var mainProductEl = self.closest('[id^="main-product-"]') || document.querySelector('[id^="main-product-"]');
        var productJsonEl = mainEl ? mainEl.querySelector('.product-json [type="application/json"]') : null;
        var productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
        var onVariantChange = function(e) {
            var variant = e.detail && e.detail.variant;
            var img = self.querySelector('.sticky-atc-image');
            if (!img) return;
            if (!productData) {
                var form = mainEl || document.querySelector('add-to-cart-form') || document.querySelector('[id^="main-product-"]');
                if (form) {
                    productJsonEl = form.querySelector('.product-json [type="application/json"]');
                    productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
                }
            }
            var src = null;
            if (variant && variant.featured_image) {
                src = variant.featured_image.src || (variant.featured_image.url ? 'https:' + variant.featured_image.url : null);
            }
            if (!src && variant && variant.featured_media && productData && productData.media) {
                var media = productData.media.find(function(m) { return m.id == variant.featured_media.id; });
                if (media && media.preview_image) {
                    src = media.preview_image.src || (media.preview_image.url ? 'https:' + media.preview_image.url : null);
                }
            }
            if (!src && img.dataset.firstImage) {
                src = img.dataset.firstImage;
            }
            if (src) img.src = src;
        };
        if (mainProductEl) mainProductEl.addEventListener('variantChange', onVariantChange);
    }

    getMainATC() {
        var info = document.querySelector('.main-product-info');
        if (!info) return null;
        return info.querySelector('button[type=submit].ProductForm__AddToCart, button[type=submit].add');
    }

    updateVisibility() {
        var mainATC = this.getMainATC();
        if (!mainATC) return;
        var rect = mainATC.getBoundingClientRect();
        var scrolledPastMainATC = rect.bottom < 0;
        if (scrolledPastMainATC) {
            this.addShow();
        } else {
            this.removeShow();
        }
    }

    addShow() {
        if (this.parentElement && !this.parentElement.classList.contains('show')) {
            this.parentElement.classList.add('show');
        }
    }

    removeShow() {
        if (this.parentElement && this.parentElement.classList.contains('show')) {
            this.parentElement.classList.remove('show');
        }
    }
}

customElements.define('sticky-atc', ComponentStickyATC); 